import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { GoalTypeDTO } from '../types/goalsDTO';

export enum DebtType {
  CreditCard = 0,
  Mortgage = 1,
  Installment = 2,
  LineOfCredit = 3,
  StudentLoan = 4,
  AutoLoan = 29,
}

export interface GoalOption {
  id: string;
  name: string;
  type: GoalTypeDTO;
  debtType: DebtType | null; // Only applicable to Debt Management goals
  goalOrigin: 'PulseCheck' | null;
}

interface GoalOptionsDTO {
  displayAssetBucketing: boolean;
  assetBucketingName: string | null;
  goals: GoalOption[];
}

interface FetcherParams {
  clientId: number;
  fpId: string;
}

const fetchGoalOptions = async ({ clientId, fpId }: FetcherParams): Promise<GoalOptionsDTO> => {
  return authFetch(urlWithParams('/Consumer/FinancialPlanWhatIfs/GoalOptions', { clientId, fpId }));
};

interface QueryParams {
  clientId: number;
  fpId: string;
}

export const useGoalOptionsQuery = ({ clientId, fpId }: QueryParams) => {
  return useQuery(
    queryKeys.goalOptions(clientId, fpId),

    () => fetchGoalOptions({ clientId, fpId }),

    {
      enabled: !!fpId,
      cacheTime: 0,
    },
  );
};
